import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { LoaderService } from '../loader/loader.service';
import { SplunkService } from '../splunk/splunk.service';
import { ClientService } from '../client/client.service';
import { AuthenticationService } from '../authentication/authentication.service';
@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private loaderService: LoaderService,
    private splunkService: SplunkService,
    private authenticationService: AuthenticationService
  ) { }
  handleError(error: Error) {
    if (error)
      this.splunkService.log('error', {
        request: error,
        response: { result: error.message ? error.message : error.toString() }
      }, this.authenticationService.getUserProfile?.UserId);
    this.loaderService.hideLoader();
    this.loaderService.handleSpinner(false);
    throw error;
  }
}
